import { servicesDataEn, servicesDataAr } from "../data/servicesData";
import { useLanguage } from "../LanguageContext";

export default function ServiceDetailView({ navigate, selectedKey }) {
  const { isAr } = useLanguage();
  const t = (en, ar) => (isAr ? ar : en);
  const servicesData = isAr ? servicesDataAr : servicesDataEn;
  const data = servicesData[selectedKey];
  if (!data) return null;

  return (
    <div className="view-enter min-h-screen flex flex-col">
      <div className="pt-24 sm:pt-28 md:pt-32 pb-10 sm:pb-12 md:pb-16 px-4 sm:px-6 bg-secondary-50 flex-grow">
        <div className="max-w-5xl mx-auto">
          <button
            onClick={() => navigate("services")}
            className="text-neutral-600 hover:text-primary-600 mb-6 sm:mb-8 flex items-center gap-2 font-bold tracking-wide transition group"
          >
            <i className={`ph-bold ${isAr ? "ph-arrow-right group-hover:translate-x-1" : "ph-arrow-left group-hover:-translate-x-1"} transition-transform`} />
            {t("Back to Services", "العودة إلى الخدمات")}
          </button>

          <div className="bg-white rounded-2xl shadow-medium overflow-hidden border border-neutral-200/50">
            <div className="h-48 sm:h-64 md:h-96 w-full relative overflow-hidden bg-gray-100">
              <img src={data.image} alt={data.title} className="w-full h-full object-cover" />
            </div>

            <div className="p-6 sm:p-8 md:p-10 lg:p-16">
              <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                <span className="w-8 sm:w-10 md:w-12 h-1 bg-primary-600" />
                <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-neutral-900 tracking-tight font-display">
                  {data.title}
                </h1>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 sm:gap-8 md:gap-12 mt-8 sm:mt-10 md:mt-12">
                {/* Overview */}
                <div className="lg:col-span-3">
                  <h3 className="text-lg sm:text-xl font-bold text-neutral-900 mb-4 sm:mb-6 flex items-center gap-2 font-display">
                    <i className="ph-fill ph-info text-primary-600 text-2xl" />
                    {t("Service Overview", "نظرة عامة على الخدمة")}
                  </h3>
                  <div className="text-neutral-600 text-sm sm:text-base md:text-lg leading-relaxed space-y-3 sm:space-y-4 font-light">
                    {data.overview.map((para, i) => (
                      <p key={i}>{para}</p>
                    ))}
                  </div>
                </div>

                {/* Capabilities */}
                <div className="lg:col-span-2 bg-primary-50 p-4 sm:p-6 md:p-8 rounded-xl border border-primary-200">
                  <h3 className="text-xl font-bold text-neutral-900 mb-6 flex items-center gap-2 font-display">
                    <i className="ph-fill ph-check-circle text-primary-600 text-2xl" />
                    {t("Key Capabilities", "القدرات الرئيسية")}
                  </h3>
                  <ul className="space-y-3 sm:space-y-4">
                    {data.capabilities.map((cap, i) => (
                      <li key={i} className="flex items-start gap-4">
                        <i className="ph-fill ph-check-circle text-primary-600 text-xl shrink-0 mt-0.5" />
                        <span className="text-gray-700 font-medium">{cap}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="py-12 sm:py-16 md:py-20 px-4 sm:px-6" style={{ backgroundColor: "rgb(17, 60, 111)" }}>
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black mb-4 sm:mb-6 font-display text-white">
            {t("Need This Service For Your Project?", "هل تحتاج هذه الخدمة لمشروعك؟")}
          </h2>
          <p className="text-white/90 mb-8 sm:mb-10 text-sm sm:text-base md:text-xl font-light">
            {t(
              "Talk to our team about schedule, scope, and technical requirements.",
              "تحدث مع فريقنا حول الجدول الزمني ونطاق العمل والمتطلبات التقنية."
            )}
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-3 sm:gap-4">
            <button
              onClick={() => navigate("contact")}
              className="bg-white text-primary-700 px-6 sm:px-8 md:px-10 py-3 sm:py-4 rounded-xl font-bold text-sm sm:text-lg hover:bg-primary-700 hover:text-white shadow-button transition-all transform hover:-translate-y-1 w-full sm:w-auto"
            >
              {t("Contact Us", "تواصل معنا")}
            </button>
            <button
              onClick={() => navigate("services")}
              className="border-2 border-white/60 text-white px-6 sm:px-8 md:px-10 py-3 sm:py-4 rounded-xl font-bold text-sm sm:text-lg hover:bg-white hover:text-primary-700 transition-all transform hover:-translate-y-1 w-full sm:w-auto"
            >
              {t("All Services", "جميع الخدمات")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
